import { createReducer, on } from '@ngrx/store';
import { FloorApiActions, FloorListActions, FloorSignalRHubActions } from './floor.actions';
import { adapter, initialState, selectFloorIdFromFloor } from './floor.state';

// ============================================================================
// FLOOR REDUCER
// ============================================================================
// Note: We will step away from using these reducers in the future, so don't
// add new ones or build upon them.
// ============================================================================

export const floorsReducer = createReducer(
  initialState,
  on(FloorApiActions.floorsLoaded, (state, { floors }) => adapter.upsertMany(floors, state)),
  on(
    FloorApiActions.floorAdded,
    FloorApiActions.floorUpdated,
    FloorApiActions.floorUpdatedError,
    FloorApiActions.floorDeletedError,
    FloorListActions.floorUpdated,
    FloorSignalRHubActions.floorUpdated,
    (state, { floor }) => adapter.upsertOne(floor, state)
  ),
  on(FloorApiActions.floorDeleted, FloorListActions.floorDeleted, (state, { floor }) =>
    adapter.removeOne(selectFloorIdFromFloor(floor), state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectFloorIds = selectIds;
export const selectFloorEntities = selectEntities;
export const selectAllFloors = selectAll;
